<template>
  <transition appear
    enter-active-class="animated fadeIn"
    leave-active-class="animated fadeOut"
  >
    <q-layout
        ref="layout"
        view="hHh LpR fFf"
        @resize="setLeftVisibility"
    >
      <q-layout-header reveal :reveal-offset="50" style="box-shadow: none">
        <q-toolbar color="faded">
          <q-btn
              v-if="$route.meta.showLeft"
              flat
              icon="menu"
              @click="leftVisible = !leftVisible"
          />
          <q-btn
              flat
              icon="fa-building"
              :class="{'router-link-active': menu === 'list'}"
              @click="$router.push('/list')"
          />
          <q-btn
              flat
              icon="fa-briefcase"
              :class="{'router-link-active': menu === 'cases'}"
              @click="$router.push('/c')"
          />
          <q-btn
              flat
              icon="fa-search"
              :class="{'router-link-active': menu === 'search'}"
              @click="onSearchClick"
          />
          <q-btn
              v-if="$store.state.syncing !== 'off'"
              flat
              icon="fas fa-images"
              :class="{'router-link-active': menu === 'medias'}"
              @click="$router.push('/x')"
          />
          <q-btn
              v-if="wikiEnabled"
              flat
              icon="fas fa-book-reader"
              :class="{'router-link-active': menu === 'wiki'}"
              @click="goWiki"
          />
          <q-toolbar-title>
          </q-toolbar-title>
          <q-btn
              v-if="$store.state.syncing === 'off'"
              flat
              color="warning"
              icon="cloud"
              @click="goOnline"
          />
          <q-btn-dropdown
              flat
              icon="fa-id-card"
              :class="{'router-link-active': menu === 'profile'}"
          >
            <q-list link>
              <q-item
                  @click.native="openURL($store.state.settings.teamUrl)"
                  v-close-overlay
              >
                <q-item-side icon="group" inverted color="secondary"/>
                <q-item-main>
                  <q-item-tile label>{{$store.state.settings.teamName}}</q-item-tile>
                </q-item-main>
              </q-item>
              <q-item @click.native="$router.push('/profile')">
                <q-item-side icon="edit" inverted color="primary"/>
                <q-item-main>
                  <q-item-tile label>{{user.screenname}}</q-item-tile>
                </q-item-main>
              </q-item>
              <q-item @click.native="$router.push('/sign-in')">
                <q-item-side icon="open_in_new" inverted color="warning"/>
                <q-item-main>
                  <q-item-tile label>Выйти</q-item-tile>
                </q-item-main>
              </q-item>
              <q-item @click.native="$router.push('/sign-in?destroy=1')">
                <q-item-side icon="open_in_new" inverted color="negative"/>
                <q-item-main>
                  <q-item-tile label>Выйти и очистить</q-item-tile>
                </q-item-main>
              </q-item>
            </q-list>
          </q-btn-dropdown>
          <q-btn
              v-if="enableRight"
              flat icon="fa-bell"
              :class="rightVisible?'accent':''"
              @click="rightVisible = !rightVisible"
          />
        </q-toolbar>
        <div>
          <div class="progress" :class="syncingClass">
            <div class="progress-track" style="width: 100%;">&nbsp;</div>
            <div class="progress-model" style="width: 0%;">&nbsp;</div>
          </div>
        </div>
      </q-layout-header>
      <q-layout-footer reveal :reveal-offset="50" style="box-shadow: none">
        <q-toolbar color="faded">
          ©alexchetv, 2022
        </q-toolbar>
      </q-layout-footer>
      <q-page-container>
        <transition appear :name="transit" mode="out-in">
          <router-view/>
        </transition>
      </q-page-container>
      <q-layout-drawer side="right" v-if="enableRight" v-model="rightVisible" :breakpoint="rightBreakpoint">
        <requests-list :items="requests" :instrumentId="instrumentId"/>
      </q-layout-drawer>
      <q-layout-drawer side="left"  ref="left" v-model="leftVisible" v-if="$route.meta.showLeft">
        <router-view name="left"/>
      </q-layout-drawer>
    </q-layout>
  </transition>
</template>

<script>

import RequestsList from 'components/requests-list';
import { openURL } from 'quasar';
import SpinnerMtech from 'components/spinner-mtech';

const CONNECTED = 1;
const DISCONNECTED = 0;
const DISABLED = -1;

export default {
  components: {
    RequestsList,
    SpinnerMtech,
  },
  name: 'app',
  data() {
    return {
      transit: 'slide-l',
      menu: '',
      rightVisible: false,
      leftVisible: true,
      reconnector: null,
    };
  },
  mounted() {
    console.log('default mounted');
  },
  beforeDestroy() {
    console.log('default  beforeDestroy');
    this.stopReconnector();
    this.$disconnect();
  },
  computed: {
    connected() {
      return ((this.$store.state.syncing === 'off') ?
        DISABLED : (this.$store.state.socket.isConnected ?
          CONNECTED : DISCONNECTED));
    },
    wikiEnabled() {
      return this.$store.getters.wikiEnabled;
    },
    rightBreakpoint() {
      return this.$route.meta.showLeft ? 1200 : 992;
    },
    requests() {
      return this.$store.state.requests;
    },
    instrumentId() {
      return (this.$route.name === 'unitView'
        && this.$route.params.id[0] === 'i') ? this.$route.params.id : (this.$route.name === 'instrumentCaseView' ? this.$route.params.iid : null);
    },
    initializing() {
      return this.$store.state.initializing;
    },
    enableRight() {
      return !!this.requests.length;
    },
    user() {
      return this.$store.state.user;
    },
    syncingClass() {
      switch (this.$store.state.syncing) {
        case 'push':
          return 'positive left';
        case 'pull':
          return 'positive right';
        case 'suspended':
          return 'negative';
        case 'off':
          return 'dead';
        default:
          return 'ready';
      }
    },
  },
  methods: {
    stopReconnector() {
      clearInterval(this.reconnector);
      this.reconnector = null;
    },
    goOnline() {
      this.$q.dialog({
        title: 'Выйти из автономного режима?',
        'prevent-close': true,
        message: 'Будет установлена связь с сервером',
        ok: {
          flat: true,
          color: 'warning',
          label: 'Выйти',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Остаться',
        },
      })
        .then(() => {
          this.$store.dispatch('startLiveSync');
        });
    },
    openURL,
    setLeftVisibility(size) {
      const width = size && size.width;
      if (size) { // need for mediator
        this.$store.commit('setPageHeight', size.height);
      }
      this.leftVisible = this.$route.meta.showLeft && ((width || window.innerWidth) > 992);
      // console.log(width, window.innerWidth, (width || window.innerWidth) > 992);
      // console.log('leftVisible', this.$route.meta.showLeft, this.leftVisible);
    },
    onSearchClick() {
      if (this.$store.state.searchResults.results.length > 0) {
        this.$router.push('/found');
      } else {
        this.$router.push('/search');
      }
    },
    goWiki() {
      this.$router.push('/wikis');
    },
  },
  watch: {
    connected: {
      handler(value) {
        if (value === DISCONNECTED) {
          console.log('STATUS = DISCONNECTED');
          this.reconnector = setInterval(() => {
            if (this.connected !== DISCONNECTED) {
              this.stopReconnector();
              this.reconnector = null;
              console.log('connection done');
            } else {
              this.$store.dispatch('waitRefresh')
                .then(() => {
                  console.log('try connect', this.$store.state.user.access_token);
                  this.$connect(`${process.env.wsUrl}/inform/${this.$store.state.user.access_token}`, {
                    store: this.$store,
                    format: 'json',
                  });
                });
            }
          }, 10000);
        } else {
          console.log('STATUS = CONNECTED');
          this.stopReconnector();
        }
      },
      immediate: true,
    },
    '$route.name': {
      handler(value) {
        console.log('WATCH route.name', value);
        this.menu = this.$route.meta.menu;
        if (this.menu !== 'wiki') {
          this.$store.commit('wiki/setW_P', []);
          this.$store.commit('wiki/setCurrentItem', null);
          this.$store.commit('wiki/setAuthorName', null);
        }
        if (value === 'list') {
          document.title = 'Объекты';
        }
        if (value === 'cases') {
          document.title = 'Кейсы';
        }
        if (value === 'wikis') {
          document.title = 'Знания';
          this.$store.commit('wiki/setCurrentItem', null);
          this.$store.commit('wiki/setAuthorName', null);
        }
        if (value === 'wikiNew') {
          this.$store.commit('wiki/setCurrentItem', null);
          this.$store.commit('wiki/setAuthorName', null);
        }
        this.setLeftVisibility();
        this.notProfile = value !== 'profile';
        this.transit = value.indexOf('New') > -1 || value.indexOf('Edit') > -1 ? 'slide-r' : 'slide-l';
      },
      immediate: true,
    },
    rightVisible: {
      handler(value) {
        this.$store.commit('setRightVisible', value);
      },
      immediate: true,
    },
  },

};
</script>

<style lang="stylus">
  @import '~variables'
  .q-toolbar
    min-height 0
    padding 0

  .accent
    i
      color $primary

  button.router-link-active
    background $primary
</style>



// WEBPACK FOOTER //
// src/layouts/default.vue